import { render, staticRenderFns } from "./JobPostCategory.vue?vue&type=template&id=73a0c638&scoped=true&"
import script from "../../../services/company/job_post/job-post-category.js?vue&type=script&lang=js&"
export * from "../../../services/company/job_post/job-post-category.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/job_category.css?vue&type=style&index=0&id=73a0c638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a0c638",
  null
  
)

export default component.exports